// extracted by mini-css-extract-plugin
export var createdDate = "_mg-1";
export var divider = "_mg-2";
export var headerDivider = "_mg-3";
export var messagesCard = "_mg-0";
export var messagesContainer = "_mg-6";
export var messagesContainerWrapper = "_mg-4";
export var showLeftPanelButton = "_mg-8";
export var topButtons = "_mg-7";
export var withPadding = "_mg-5";